// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1324":"3b25391f","3471":"3b25391f","3505":"b9b99098","4127":"ae0ad74b","5027":"5377c777","6375":"496f2f66","7684":"db55546a","7850":"f9254a1b","8272":"53978d44"}[chunkId] + ".chunk.css";
};